var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 125,
    viewBox: "0 0 281 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11596_106604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 92.8647H44.1768C45.9566 92.8647 47.6076 94.0502 47.6421 95.8296C47.8327 105.66 34.4994 112.361 28.5189 114.868C27.9965 115.087 28.1698 115.916 28.7355 115.886C52.5774 114.65 73.0207 99.3713 79.386 93.8968C80.147 93.2423 81.1072 92.8647 82.1109 92.8647H242C259.673 92.8647 274 78.5378 274 60.8647V37C274 19.3269 259.673 5 242 5H39C21.3269 5 7 19.3269 7 37V60.8647C7 78.5378 21.3269 92.8647 39 92.8647Z",
    stroke: "url(#paint0_linear_11596_106604)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11596_106604",
    x: 0.5,
    y: 0.5,
    width: 280,
    height: 123.888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.854902 0 0 0 0 0.854902 0 0 0 0 0.854902 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11596_106604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11596_106604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11596_106604",
    x1: -190.612,
    y1: -20.4297,
    x2: -174.156,
    y2: 133.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443013,
    stopColor: "#202261"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#543C97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#6939A2"
  })))));
};
export { SvgMessage as ReactComponent };
export default "data:image/svg+xml;base64,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";